module.exports = __webpack_public_path__ + "static/DMSans-Italic-f45d96d5971cc6fe46d01dd2f32bed99.woff2";